import {
  addAccountingDetailsAPI,
  deleteAccountingDetailsAPI,
  getAccountingDetailsAPI,
  getPostedInvoiceByOrganizationIdAPI,
  getPostedInvoiceByUserIdAPI,
  updateAccountingDetailsAPI,
  updateInvoiceDetailsAPI,
} from "./api";

export const addAccountingDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    addAccountingDetailsAPI(id, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const updateAccountingDetails = (data) => {
  return new Promise((resolve, reject) => {
    updateAccountingDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateInvoiceDetails = (params, data) => {
  return new Promise((resolve, reject) => {
    updateInvoiceDetailsAPI(params, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAccountingDetails = (data) => {
  return new Promise((resolve, reject) => {
    getAccountingDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteAccountingDetails = (data) => {
  return new Promise((resolve, reject) => {
    deleteAccountingDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export const getPostedInvoiceByOrganizationId = (data) => {
  return new Promise((resolve, reject) => {
    getPostedInvoiceByOrganizationIdAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPostedInvoiceByUserId = (opsId) => {
  return new Promise((resolve, reject) => {
    getPostedInvoiceByUserIdAPI(opsId)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
